/* Cart Drawer Pro extras - MeraFashion.
   Two-stage milestone (free shipping from the first cent, free gift at the
   threshold) plus a small always-on shipping-protection toggle.
   Runs alongside cdp-cart.js and listens to the cdp:updated event it fires.
   Loaded BEFORE cdp-cart.js so the listener is attached before the first render. */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.cdpExtras) return;
  root.dataset.cdpExtras = '1';

  function readJSON(id, fallback) {
    var el = document.getElementById(id);
    if (!el) return fallback;
    try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
  }

  var X = readJSON('CartDrawerProExtras', {});
  var SHIP_MIN = Number(X.shipMin) || 1;
  var GIFT_MIN = Number(X.giftMin) || 10000;
  var PROT_VID = Number(X.protectionVariantId) || 0;
  var PROT_PRICE = Number(X.protectionPrice) || 0;
  var GIFT_VID = Number(X.giftVariantId) || 0;
  var FMT = X.moneyFormat || '{{amount_with_comma_separator}}';

  var RE_THOUSANDS = new RegExp('([0-9])(?=([0-9][0-9][0-9])+(?![0-9]))', 'g');
  var RE_PLACEHOLDER = new RegExp('[{][{][ ]*([a-z_]+)[ ]*[}][}]', 'g');

  function money(cents) {
    cents = Number(cents) || 0;
    function num(v, p, t, d) {
      var parts = (v / 100).toFixed(p).split('.');
      var whole = parts[0].replace(RE_THOUSANDS, '$1' + t);
      return p ? whole + d + parts[1] : whole;
    }
    return FMT.replace(RE_PLACEHOLDER, function (m, key) {
      switch (key) {
        case 'amount': return num(cents, 2, ',', '.');
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_space_separator': return num(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(cents, 0, ' ', ',');
        default: return num(cents, 2, ',', '.');
      }
    });
  }

  var $ = function (sel) { return root.querySelector(sel); };
  var ms = $('[data-cdp-ms]');
  var msText = $('[data-cdp-ms-text]');
  var msFill = $('[data-cdp-ms-fill]');
  var msShip = $('[data-cdp-ms-ship]');
  var msGift = $('[data-cdp-ms-gift]');
  var prot = $('[data-cdp-prot]');
  var protSw = $('[data-cdp-prot-sw]');
  var protPrice = $('[data-cdp-prot-price]');

  function isProt(i) { return !!PROT_VID && Number(i.variant_id) === PROT_VID; }
  function isGift(i) { return !!GIFT_VID && Number(i.variant_id) === GIFT_VID; }

  function merchandiseSubtotal(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.final_line_price);
    }, 0);
  }
  function realCount(cart) {
    return (cart.items || []).reduce(function (n, i) {
      return n + (isProt(i) || isGift(i) ? 0 : i.quantity);
    }, 0);
  }
  function setDeclined(v) {
    try {
      if (v) { sessionStorage.setItem('cdp_protect_off', '1'); }
      else { sessionStorage.removeItem('cdp_protect_off'); }
    } catch (e) {}
  }

  var RE_AMP = new RegExp('&', 'g');
  var RE_LT = new RegExp('<', 'g');
  var RE_GT = new RegExp('>', 'g');
  function esc(t) {
    return String(t == null ? '' : t)
      .replace(RE_AMP, '&amp;').replace(RE_LT, '&lt;').replace(RE_GT, '&gt;');
  }

  function paint(cart) {
    if (!cart) return;
    var sub = merchandiseSubtotal(cart);
    var n = realCount(cart);

    if (ms) {
      ms.hidden = n === 0;
      var pct = GIFT_MIN > 0 ? Math.round((sub / GIFT_MIN) * 100) : 100;
      pct = Math.max(0, Math.min(100, pct));
      if (msFill) msFill.style.width = pct + '%';
      if (msText) {
        if (sub >= GIFT_MIN) {
          msText.innerHTML = esc(X.textGift || 'Free shipping and your free gift are unlocked');
        } else if (sub >= SHIP_MIN) {
          msText.innerHTML = esc(X.textMid || 'Free shipping unlocked - [amount] away from your free gift')
            .replace('[amount]', '<b>' + money(GIFT_MIN - sub) + '</b>');
        } else {
          msText.innerHTML = esc(X.textStart || 'Free shipping on every order');
        }
      }
      if (msShip) msShip.classList.toggle('is-on', sub >= SHIP_MIN);
      if (msGift) msGift.classList.toggle('is-on', sub >= GIFT_MIN);
    }

    if (prot && PROT_VID) {
      prot.hidden = n === 0;
      var on = (cart.items || []).some(isProt);
      prot.classList.toggle('is-on', on);
      if (protSw) protSw.setAttribute('aria-checked', on ? 'true' : 'false');
      if (protPrice) protPrice.textContent = money(PROT_PRICE);
    }
  }

  document.addEventListener('cdp:updated', function (e) {
    paint(e && e.detail && e.detail.cart);
  });

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function finish() {
    if (prot) prot.classList.remove('is-busy');
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  if (protSw) {
    protSw.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!PROT_VID || !prot || prot.classList.contains('is-busy')) return;
      var on = protSw.getAttribute('aria-checked') === 'true';
      prot.classList.add('is-busy');
      prot.classList.toggle('is-on', !on);
      protSw.setAttribute('aria-checked', on ? 'false' : 'true');

      if (on) {
        setDeclined(true);
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var line = (c.items || []).filter(isProt)[0];
            if (!line) return null;
            return post('/cart/change.js', { id: line.key, quantity: 0 });
          })
          .then(finish, finish);
      } else {
        setDeclined(false);
        post('/cart/add.js', { items: [{ id: PROT_VID, quantity: 1 }] }).then(finish, finish);
      }
    });
  }

  paint(readJSON('CartDrawerProCart', null));
})();

/* 2nd pair nudge (Claude, Oct 2026): one quiet line under the items - automatic discount, no promo code */
(function () {
  'use strict';
  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.cdpPair) return;
  root.dataset.cdpPair = '1';
  var items = root.querySelector('[data-cdp-items]');
  if (!items) return;
  var X = {};
  try { X = JSON.parse((document.getElementById('CartDrawerProExtras') || {}).textContent || '{}') || {}; } catch (e) {}
  var FMT = X.moneyFormat || '{{amount}}';
  function grp(w, t) { return w.replace(/\B(?=(\d{3})+(?!\d))/g, t); }
  function money(cents) {
    var v = ((Number(cents) || 0) / 100).toFixed(2).split('.');
    return FMT.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, function (m, key) {
      var noDec = /no_decimals/.test(key), comma = /comma_separator/.test(key), space = /space_separator/.test(key);
      var whole = grp(v[0], comma ? '.' : (space ? ' ' : ','));
      return noDec ? whole : whole + (comma || space ? ',' : '.') + v[1];
    });
  }
  var el = document.createElement('div');
  el.className = 'cdp__pair';
  el.hidden = true;
  items.insertAdjacentElement('afterend', el);
  var RE = /2e paar|2nd pair|second pair|tweede paar/i;
  function isSneaker(i) {
    var t = String(i.product_type || '').toLowerCase(), h = String(i.handle || '').toLowerCase();
    if (/sock|sokken/.test(h)) return false;
    return t === 'sneakers' || t === 'boots';
  }
  function paint(cart) {
    if (!cart || !cart.items || !cart.items.length) { el.hidden = true; return; }
    var pairs = 0, saved = 0;
    cart.items.forEach(function (i) {
      if (isSneaker(i)) pairs += Number(i.quantity) || 0;
      (i.line_level_discount_allocations || []).forEach(function (d) {
        if (d && d.discount_application && RE.test(d.discount_application.title || '')) saved += Number(d.amount) || 0;
      });
    });
    if (saved > 0) {
      el.className = 'cdp__pair is-on';
      el.innerHTML = '<span class="cdp__pair-ico">&#10003;</span><span>2nd pair discount applied &mdash; you save <b>' + money(saved) + '</b></span>';
      el.hidden = false;
    } else if (pairs === 1) {
      el.className = 'cdp__pair';
      el.innerHTML = '<span class="cdp__pair-ico">+</span><span>Add a 2nd pair of sneakers &mdash; <b>10% off</b> the second pair, applied automatically</span>';
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }
  document.addEventListener('cdp:updated', function (e) { paint(e.detail && e.detail.cart); });
  try { paint(JSON.parse((document.getElementById('CartDrawerProCart') || {}).textContent || 'null')); } catch (e) {}
})();
